import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import FunnelStep from 'client/components/funnelStep';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import { titleCase } from 'client/utils/format';

import { saveAddressToApp } from 'client/actions/address';

const propTypes = {
  visionApp: PropTypes.shape({
    app_id: PropTypes.string.isRequired,
  }).isRequired,
  saveAddressToApp: PropTypes.func.isRequired,
  geo: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]).isRequired,
  user: PropTypes.object,
  members: PropTypes.arrayOf(PropTypes.object),
  router: PropTypes.object.isRequired,
};

const defaultProps = {
  user: null,
  members: [],
};

const mapStateToProps = state => ({
  visionApp: _.find(state.ifpApps, { type: 'vision' }),
  geo: _.get(state, 'geo', []),
  user: state.user,
  members: state.members,
});

export class CountyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    if (!this.props.geo.length || this.props.geo.length < 2) {
      this.props.router.replace('/onboarding/location');
    }
  }

  setSubmitting(state) {
    this.setState({
      isSubmitting: state,
    });
  }

  selectCounty(address) {
    const { user, members } = this.props;
    let updatedAddress = address;
    let member_id;

    this.setSubmitting(true);

    if (user.isLoggedIn) {
      const primaryMember = _.find(members, { type: 'primary' });
      const primaryAddress = _.get(primaryMember, 'address');
      updatedAddress = { ...primaryAddress, ...address };
      member_id = primaryMember.id;
    }

    const payload = {
      address: updatedAddress,
      app_ids: [this.props.visionApp.app_id],
    };

    return this.props
      .saveAddressToApp(payload, member_id ? { member_id } : null)
      .then(() => {
        this.props.router.push('/onboarding/applicants');
      })
      .catch(() => this.setSubmitting(false));
  }

  renderCounties() {
    const { geo } = this.props;
    if (geo && geo.length) {
      return (
        <div style={{ paddingTop: 50 }}>
          {geo.map(address => (
            <Button
              className="cta-button ghost-button margin-top"
              key={address.county}
              clickHandler={(event) => {
                event.preventDefault();
                this.selectCounty(address);
              }}>
              <div>{titleCase(address.county)}</div>
              <div
                style={{
                  textTransform: 'uppercase',
                  fontSize: 13,
                  fontWeight: 500,
                  paddingTop: 8,
                }}>
                {address.city}, {address.state}
              </div>
            </Button>
          ))}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <FunnelStep index={0} pathName="location" descriptKey="vision.nav.location">
        <div className="county-parent">
          <div className="onboarding-center-col text-center pad-x">
            <div className="header">
              <Translate path="common.county" />
            </div>

            <h5>
              <Translate path="common.multiCounty" />
            </h5>
            {this.renderCounties()}
          </div>
        </div>
      </FunnelStep>
    );
  }
}

CountyPage.propTypes = propTypes;
CountyPage.defaultProps = defaultProps;
export default connect(mapStateToProps, { saveAddressToApp })(CountyPage);
